import InfiniteScroll from "../../shared/InfiniteScroll";
import React, {FC, Fragment, ReactNode, Dispatch, SetStateAction} from "react";
import cls from "./category.module.scss";
import CustomPagination from "./CustomPagination/CustomPagination";

const InfiniteContentLayout: FC<{
    isInfinite?: boolean;
    children: ReactNode;
    pageCount: number;
    getPages: Array<number>
    isMobile: boolean;
}> = (
    {
        isInfinite,
        children,
        pageCount,
        getPages,
        isMobile
    }
) => {

    if (isInfinite) {
        return (
            <InfiniteScroll total={pageCount} children={children} isMobile={isMobile}/>
        )
    }
    return <Fragment>
        {children}
        {pageCount > 1 ? (
            <div style={{margin: "47px 0"}}>
                <div>
                    <div className={cls["posts-view__pagination"]}>
                        <CustomPagination total={pageCount} getPages={getPages}/>
                    </div>
                </div>
            </div>
        ) : <Fragment />}
    </Fragment>
}

export default InfiniteContentLayout;
